module.exports = __webpack_public_path__ + "static/media/gallery6.915a14f9.png";